import { num, obj } from "@agrigate/ts-utils/lib/zod";
import * as z from "zod/v4";
export function PageOf(itemType) {
    return obj({
        items: z.array(itemType),
        page: PageInfo,
    });
}
export const PageInfo = obj({
    num,
    size: num,
});
export const PageInput = PageInfo.partial();
//# sourceMappingURL=pagination.js.map